import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import moment from 'moment/moment';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-all-data-date-filter',
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.scss'],
  imports: [
    MatFormField,
    MatInput,
    MatDatepickerInput,
    FormsModule,
    MatLabel,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
  ],
})
export class AllDataDateFilterComponent implements OnInit {
  @Input() set data(value: { dateFrom?: Date; dateTo?: Date } | undefined) {
    if (!value) {
      this.dateFrom = undefined;
      this.dateTo = undefined;

      return;
    }

    const { dateFrom, dateTo } = value;

    this.dateFrom = dateFrom;
    this.dateTo = dateTo;
  }

  @Input() onClear!: Subject<void>;

  @Output() dateFilterChange = new EventEmitter<{
    dateFrom?: string;
    dateTo?: string;
  }>();

  dateFrom?: Date;
  dateTo?: Date;

  today = new Date();

  ngOnInit(): void {
    this.onClear.subscribe(() => {
      this.dateFrom = undefined;
      this.dateTo = undefined;
    });
  }

  onDateChange() {
    this.dateFilterChange.emit({
      dateFrom: this.dateFrom ? moment(this.dateFrom).format('YYYY-MM-DD') : undefined,
      dateTo: this.dateTo ? moment(this.dateTo).format('YYYY-MM-DD') : undefined,
    });
  }
}
